import { render, staticRenderFns } from "./ModalSubmittalDetails.vue?vue&type=template&id=41fd0c9f&lang=pug&"
import script from "./ModalSubmittalDetails.vue?vue&type=script&lang=js&"
export * from "./ModalSubmittalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports